import React from 'react';
import { useConsent } from '../../contexts/ConsentContext';
import './style.css';

const CookieBanner = () => {
  const { bannerVisible, consentRequired, accept, reject } = useConsent();

  if (!consentRequired || !bannerVisible) {
    return null;
  }

  return (
    <div className="cookie-banner">
      <div className="cookie-banner-content">
        <div className="cookie-banner-title">We value your privacy</div>
        <div className="cookie-banner-text">
          We use cookies and similar technologies to analyze usage and improve your experience. 
          By clicking "Accept", you consent to our use of analytics cookies.
        </div>
      </div>
      <div className="cookie-banner-actions">
        <button className="cookie-btn cookie-btn-secondary" type="button" onClick={reject}>
          Decline
        </button>
        <button className="cookie-btn cookie-btn-primary" type="button" onClick={accept}>
          Accept All
        </button>
      </div>
    </div>
  );
};

export default CookieBanner;
